// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__bwgY8 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_btnWrapper__F2v0N {
  height: 57px;
}

.styles_contentWrapper__Rwa4Q {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .styles_contentWrapper__Rwa4Q {
    gap: 24px;
  }
}

.styles_inputListWrapper__SiP0o {
  display: flex;
  flex-direction: column;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/CardNavNew/cardToolbar/settingsModal/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AADF;ACgBE;EDnBF;IAOI,SAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.btnWrapper {\n  height: 57px;\n}\n\n.contentWrapper {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @include md {\n    gap: 24px;\n  }\n}\n\n.inputListWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__bwgY8`,
	"btnWrapper": `styles_btnWrapper__F2v0N`,
	"contentWrapper": `styles_contentWrapper__Rwa4Q`,
	"inputListWrapper": `styles_inputListWrapper__SiP0o`
};
export default ___CSS_LOADER_EXPORT___;
